import {
    Temperature,
    TemperatureKey,
} from "@/pages/CalculationPage/sections/functional-properties-prediction/components/conditions/TemperatureSelect/TemperatureSelect.types";

export const temperatures: Record<TemperatureKey, Temperature> = {
    [TemperatureKey.T20]: { key: TemperatureKey.T20, value: 20, unit: "°C" },
    [TemperatureKey.T25]: { key: TemperatureKey.T25, value: 25, unit: "°C" },
};

export const DEFAULT_TEMPERATURE_KEY = TemperatureKey.T20;
